<template>
    <div class="offer" :class="{ 'recommended': isRecommended, 'placeholder-wrap': !offer, 'tooltip-active': activeOfferTooltipId === offer.id }">
        <div class="offer-body" :class="{ 'recommended': isRecommended, 'placeholder-wrap': !offer, 'tooltip-active': activeOfferTooltipId === offer.id, dicount: offer?.coupon }">
            <div class="offer-body__seller">
                <OfferSellerInfo 
                    :isOnlineGame="isOnlineGame" 
                    :offer="offer" 
                    :mobile="mobile" 
                    :tablet="tablet" 
                    :elClass="'offer-list'" 
                    :seller="offer?.user ? offer.user : {}" 
                    :simplified="true"
                    @open:modal="showModalSellerInfoFun(true)"
                />
                <OfferSellerTooltip 
                    v-if="!tablet" 
                    :showModalSellerInfo="showModalSellerInfo" 
                    :mobile="mobile" 
                    :offer="offer" 
                    :seller="offer?.user ? offer.user : {}"
                    @close:modal="showModalSellerInfoFun(false)"
                />
                <div class="offer-body__tooltip" :class="{show: activeOfferTooltipId === offer.id}" v-if="offer?.id && mobile">
                    <div class="offer-body__tooltip-btn" @click="toggleTooltipOffer(offer.id)">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M10 12C10 12.5304 10.2107 13.0391 10.5858 13.4142C10.9609 13.7893 11.4696 14 12 14C12.5304 14 13.0391 13.7893 13.4142 13.4142C13.7893 13.0391 14 12.5304 14 12C14 11.4696 13.7893 10.9609 13.4142 10.5858C13.0391 10.2107 12.5304 10 12 10C11.4696 10 10.9609 10.2107 10.5858 10.5858C10.2107 10.9609 10 11.4696 10 12ZM10 6C10 6.53043 10.2107 7.03914 10.5858 7.41421C10.9609 7.78929 11.4696 8 12 8C12.5304 8 13.0391 7.78929 13.4142 7.41421C13.7893 7.03914 14 6.53043 14 6C14 5.46957 13.7893 4.96086 13.4142 4.58579C13.0391 4.21071 12.5304 4 12 4C11.4696 4 10.9609 4.21071 10.5858 4.58579C10.2107 4.96086 10 5.46957 10 6ZM10 18C10 18.5304 10.2107 19.0391 10.5858 19.4142C10.9609 19.7893 11.4696 20 12 20C12.5304 20 13.0391 19.7893 13.4142 19.4142C13.7893 19.0391 14 18.5304 14 18C14 17.4696 13.7893 16.9609 13.4142 16.5858C13.0391 16.2107 12.5304 16 12 16C11.4696 16 10.9609 16.2107 10.5858 16.5858C10.2107 16.9609 10 17.4696 10 18Z" fill="#9D9D9D"/>
                        </svg>
                    </div>
                    <div class="offer-body__tooltip-body" :class="{active: activeOfferTooltipId === offer.id}">
                        <OfferDetailsModal @update-cart="forwardUpdateCart" :mobile="true" :offer="offer" :isOnlineGame="isOnlineGame" :tooltip="true"/>
                        <Bookmark v-if="user" :requestId="offer.id" :is_bookmark="offer.is_bookmark" :request="'offer_id'"
                            @update:bookmark="({ id, newStatus }) => $emit('update:bookmark', { id, newStatus })" :title="true"/>
                        <SocialOfferInfo ref="socialOfferInfo" :offerId="offer.id" :clickable="true"/>
                    </div>
                </div>
            </div>
            <span class="offer-body__line" v-if="!mobile"></span>
            <template v-if="!isOnlineGame && !mobile">
                <OfferIconsInfo :offer="offer" :showEdition="!bigDesktop || w1199" :isOnlineGame="isOnlineGame"/>
                <span class="offer-body__line"></span>
            </template>
            <div class="offer-body__region" v-if="!tablet && !mobile" :class="isOnlineGame ? 'online-game' : 'game'">
                <div class="offer-body__region-online" v-if="isOnlineGame">
                    <div class="flex-column">
                        <div class="flex-item title" v-if="offer?.additional_data?.game_server">
                            <img src="/img/pages/product/icons/server.svg" alt="server">
                            {{ $t('Server') }}:
                        </div>
                        <div class="flex-item title" v-if="offer?.additional_data?.game_fraction">
                            <img src="/img/pages/product/icons/faction.svg" alt="faction">
                            {{ $t('Faction') }}:
                        </div>
                        <!-- <div v-if="offer?.game_edition" class="flex-item title">
                            <img src="/img/pages/product/icons/faction.svg" alt="faction">
                            {{ $t('Faction') }}:
                        </div> -->
                    </div>
                    <div class="flex-column">
                        <div class="flex-item" v-if="offer?.additional_data?.game_server">
                            {{ offer.additional_data.game_server }}
                        </div>
                        <div class="flex-item" v-if="offer?.additional_data?.game_fraction">
                            {{ offer.additional_data.game_fraction }}
                        </div>
                        <!-- <div class="flex-item" v-if="offer?.game_edition">
                            {{ offer.game_edition?.name }}
                        </div> -->
                    </div>
                </div>
                <RegionOffer type="folded" :offer="offer" :typeIcon="1" v-else/>
                <OfferTooltipInfo :offer="offer" :isOnlineGame="isOnlineGame"/>
            </div>
            <span class="offer-body__line hide-line" v-if="!tablet && !mobile"></span>
            <div class="offer-body__edition" v-if="bigDesktop && !isOnlineGame">
                <div v-if="offer?.game_edition" class="flex-item title">
                    <img src="/img/pages/product/icons/edition.svg" alt="edition">
                    {{ $t('Edition') }}:
                </div>
                <div class="flex-item" v-if="offer?.game_edition">
                    {{ offer.game_edition?.name }}
                </div>
            </div>
            <span class="offer-body__line" v-if="bigDesktop && !isOnlineGame && !mobile"></span>
            <template v-if="isOnlineGame && !mobile">
                <div class="offer-body__price online stock">
                    <div class="offer-body__price-top" v-if="offer?.id" v-html="`${$t('In Stock')} (<b>${productData?.currency_unit ? productData?.currency_unit : ''}</b> ${productData?.game_currency})`"></div>
                    <div class="offer-body__price-top placeholder" v-else></div>
                    <div class="offer-body__price-bottom" v-if="offer?.offer_price">{{formatCurrency(offer.stock, productData?.currency_unit, true)}}</div>
                    <div class="offer-body__price-bottom placeholder" v-else></div>
                </div>
                <span class="offer-body__line"></span>
            </template>
            <div class="offer-body__price" v-if="!mobile" :class="isOnlineGame ? 'online' : 'game'">
                <div class="offer-body__price-top" v-if="offer?.id && !offer?.coupon" v-html="isOnlineGame 
                        ? `${$t('Price in')} ${offer.offer_price.currency.symbol} / ${offer.min_order_quantity} <b>${productData?.currency_unit ? productData?.currency_unit : ''}</b> ${productData?.game_currency}` 
                        : ( tablet ?  $t('Total amount') : $t('Price')) ">
                </div>
                <div class="offer-body__price-top discount-offer" :class="{game: !isOnlineGame}" v-else-if="offer?.id && offer?.coupon">
                    <span v-if="isOnlineGame && !tablet" v-html="`${$t('Price in')} ${offer.offer_price.currency.symbol} / ${offer.min_order_quantity} <b>${productData?.currency_unit ? productData?.currency_unit : ''}</b> ${productData?.game_currency}`"></span>
                    <div class="discount-offer__percent" @click.stop="copyToClipboard(offer.coupon.code)">
                        <span class="discount-offer__percent-bold">
                            {{ '-'+offer.coupon.value+ '%' }}
                        </span>
                        <div class="discount-offer__percent-code">
                            <span>{{ offer.coupon.code }}</span>
                            <img class="copy-button" src="/img/pages/product/icons/copy-green.svg" alt="copy">
                        </div>
                    </div>
                    <span v-if="!isOnlineGame || tablet" class="discount-offer__old-price">{{formatCurrency(offer.offer_price.price, offer.offer_price.currency.symbol, false, offer.min_order_quantity)}}</span>
                </div>
                <div class="offer-body__price-top placeholder" v-else></div>
                <div class="offer-body__price-bottom" :class="{'discount-offer': offer?.coupon}" v-if="offer?.offer_price">
                    <template v-if="isOnlineGame">
                        <span v-if="offer?.coupon && !tablet" class="discount-offer__old-price">{{formatCurrency(offer.offer_price.price, offer.offer_price.currency.symbol, false, offer.min_order_quantity)}}</span>
                        <span class="bold-price">
                            {{ offer?.coupon ? formatCouponePrice(offer.offer_price.price, offer.offer_price.currency.symbol, offer.coupon.value, offer.min_order_quantity) : formatCurrency(offer.offer_price.price, offer.offer_price.currency.symbol, false, offer.min_order_quantity)}}
                        </span>
                    </template>
                    <template v-else>
                        {{ offer?.coupon ? formatCouponePrice(offer.offer_price.price, offer.offer_price.currency.symbol, offer.coupon.value, offer.min_order_quantity) : formatCurrency(offer.offer_price.price, offer.offer_price.currency.symbol, false, offer.min_order_quantity)}}
                    </template>
                </div>
                <div class="offer-body__price-bottom placeholder" v-else></div>
            </div>
            <span class="offer-body__line" v-if="!mobile"></span>
            <OfferDetailsModal v-if="!tablet && !mobile" @update-cart="forwardUpdateCart" :isOnlineGame="isOnlineGame" :offer="offer"/>
            <span class="offer-body__line" :class="{'hide-line': isOnlineGame}" v-if="offer?.id && !tablet && !mobile"></span>
            <div class="offer-body__tooltip" :class="{show: activeOfferTooltipId === offer.id}" v-if="offer?.id && !mobile">
                <div class="offer-body__tooltip-btn" @click="toggleTooltipOffer(offer.id)">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M10 12C10 12.5304 10.2107 13.0391 10.5858 13.4142C10.9609 13.7893 11.4696 14 12 14C12.5304 14 13.0391 13.7893 13.4142 13.4142C13.7893 13.0391 14 12.5304 14 12C14 11.4696 13.7893 10.9609 13.4142 10.5858C13.0391 10.2107 12.5304 10 12 10C11.4696 10 10.9609 10.2107 10.5858 10.5858C10.2107 10.9609 10 11.4696 10 12ZM10 6C10 6.53043 10.2107 7.03914 10.5858 7.41421C10.9609 7.78929 11.4696 8 12 8C12.5304 8 13.0391 7.78929 13.4142 7.41421C13.7893 7.03914 14 6.53043 14 6C14 5.46957 13.7893 4.96086 13.4142 4.58579C13.0391 4.21071 12.5304 4 12 4C11.4696 4 10.9609 4.21071 10.5858 4.58579C10.2107 4.96086 10 5.46957 10 6ZM10 18C10 18.5304 10.2107 19.0391 10.5858 19.4142C10.9609 19.7893 11.4696 20 12 20C12.5304 20 13.0391 19.7893 13.4142 19.4142C13.7893 19.0391 14 18.5304 14 18C14 17.4696 13.7893 16.9609 13.4142 16.5858C13.0391 16.2107 12.5304 16 12 16C11.4696 16 10.9609 16.2107 10.5858 16.5858C10.2107 16.9609 10 17.4696 10 18Z" fill="#9D9D9D"/>
                    </svg>
                </div>
                <div class="offer-body__tooltip-body" :class="{active: activeOfferTooltipId === offer.id}">
                    <OfferDetailsModal @update-cart="forwardUpdateCart" :offer="offer" :isOnlineGame="isOnlineGame" :tooltip="true"/>
                    <Bookmark v-if="user" :requestId="offer.id" :is_bookmark="offer.is_bookmark" :request="'offer_id'"
                        @update:bookmark="({ id, newStatus }) => $emit('update:bookmark', { id, newStatus })" :title="true"/>
                    <SocialOfferInfo ref="socialOfferInfo" :offerId="offer.id" :clickable="true"/>
                </div>
            </div>
            <div class="offer-body__mobile" v-else-if="mobile && !isOnlineGame">
                <OfferIconsInfo :offer="offer" :isOnlineGame="false"/>
                <div class="offer-body__mobile-region">
                    <RegionOffer type="folded" :offer="offer" :shorted="true" :typeIcon="1"/>
                    <OfferTooltipInfo :offer="offer" :mobile="mobile" :isOnlineGame="isOnlineGame"/>
                </div>
            </div>
        </div>
        <div class="offer__discount" v-if="mobile && offer?.coupon" @click.stop="copyToClipboard(offer.coupon.code)">
            <div class="offer__discount-left">
                <span class="offer__discount-left-title">{{ $t('Discount') }}:</span>
                <span class="offer__discount-left-percent">{{ '-'+offer.coupon.value+ ' %' }}</span>
            </div>
            <div class="offer__discount-right">
                <span class="offer__discount-right-code">{{ offer.coupon.code }}</span>
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g clip-path="url(#clip0_1187_18908)">
                    <path d="M11.3332 12.1665C11.3332 12.6085 11.1576 13.0325 10.845 13.345C10.5325 13.6576 10.1085 13.8332 9.6665 13.8332H3.83317C3.39114 13.8332 2.96722 13.6576 2.65466 13.345C2.3421 13.0325 2.1665 12.6085 2.1665 12.1665V6.33317C2.1665 5.89114 2.3421 5.46722 2.65466 5.15466C2.96722 4.8421 3.39114 4.6665 3.83317 4.6665V5.49984C3.61216 5.49984 3.4002 5.58763 3.24391 5.74392C3.08763 5.9002 2.99984 6.11216 2.99984 6.33317V12.1665C2.99984 12.3875 3.08763 12.5995 3.24391 12.7558C3.4002 12.912 3.61216 12.9998 3.83317 12.9998H9.6665C9.88752 12.9998 10.0995 12.912 10.2558 12.7558C10.412 12.5995 10.4998 12.3875 10.4998 12.1665H11.3332Z" fill="#505050"/>
                    <path d="M6.33317 2.99984C6.11216 2.99984 5.9002 3.08763 5.74392 3.24391C5.58763 3.4002 5.49984 3.61216 5.49984 3.83317V9.6665C5.49984 9.88752 5.58763 10.0995 5.74392 10.2558C5.9002 10.412 6.11216 10.4998 6.33317 10.4998H12.1665C12.3875 10.4998 12.5995 10.412 12.7558 10.2558C12.912 10.0995 12.9998 9.88752 12.9998 9.6665V3.83317C12.9998 3.61216 12.912 3.4002 12.7558 3.24391C12.5995 3.08763 12.3875 2.99984 12.1665 2.99984H6.33317ZM6.33317 2.1665H12.1665C12.6085 2.1665 13.0325 2.3421 13.345 2.65466C13.6576 2.96722 13.8332 3.39114 13.8332 3.83317V9.6665C13.8332 10.1085 13.6576 10.5325 13.345 10.845C13.0325 11.1576 12.6085 11.3332 12.1665 11.3332H6.33317C5.89114 11.3332 5.46722 11.1576 5.15466 10.845C4.8421 10.5325 4.6665 10.1085 4.6665 9.6665V3.83317C4.6665 3.39114 4.8421 2.96722 5.15466 2.65466C5.46722 2.3421 5.89114 2.1665 6.33317 2.1665Z" fill="#505050"/>
                    </g>
                    <defs>
                    <clipPath id="clip0_1187_18908">
                    <rect width="16" height="16" fill="white"/>
                    </clipPath>
                    </defs>
                </svg>
            </div>
        </div>
        <div class="offer-btn" :class="{'placeholder-wrap': !offer.id}">
            <template v-if="mobile">
                <template v-if="isOnlineGame">
                    <div class="offer-body__price mobile online stock">
                        <div class="offer-body__price-top" v-if="offer?.id" v-html="`${$t('In Stock')} (<b>${productData?.currency_unit ? productData?.currency_unit : ''}</b> ${productData?.game_currency})`"></div>
                        <div class="offer-body__price-top placeholder" v-else></div>
                        <div class="offer-body__price-bottom" v-if="offer?.offer_price">{{formatCurrency(offer.stock, productData?.currency_unit, true)}}</div>
                        <div class="offer-body__price-bottom placeholder" v-else></div>
                    </div>
                    <span class="offer-body__line mobile"></span>
                </template>
                <div class="offer-body__price mobile" :class="{online: isOnlineGame}">
                    <div class="offer-body__price-top" v-if="offer?.id && isOnlineGame" v-html="`${$t('Price in')} ${offer.offer_price.currency.symbol} / ${offer.min_order_quantity} <b>${productData?.currency_unit ? productData?.currency_unit : ''}</b> ${productData?.game_currency}`">
                    </div>
                    <div class="offer-body__price-top placeholder" v-else-if="isOnlineGame"></div>
                    <div class="offer-body__price-bottom" :class="{'discount-offer': offer?.coupon, online: isOnlineGame}" v-if="offer?.offer_price">
                        <template v-if="offer?.coupon">
                            <span class="discount-offer__old-price">{{formatCurrency(offer.offer_price.price, offer.offer_price.currency.symbol, false, offer.min_order_quantity)}}</span>
                            <span class="discount-offer__new-price">{{formatCouponePrice(offer.offer_price.price, offer.offer_price.currency.symbol, offer.coupon.value, offer.min_order_quantity)}}</span>
                        </template>
                        <template v-else>
                            {{formatCurrency(offer.offer_price.price, offer.offer_price.currency.symbol, false, offer.min_order_quantity)}}
                        </template>
                    </div>
                    <div class="offer-body__price-bottom placeholder" v-else></div>
                </div>
            </template>
            <button class="btn offer-btn__add-to-cart" v-if="offer?.id && offer.user.id === user?.id"
                @click="redirectToOffer(offer.id)">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <path d="M20.71 7.04055C21.1 6.65055 21.1 6.00055 20.71 5.63055L18.37 3.29055C18 2.90055 17.35 2.90055 16.96 3.29055L15.12 5.12055L18.87 8.87055M3 17.2506V21.0006H6.75L17.81 9.93055L14.06 6.18055L3 17.2506Z" fill="white"/>
                </svg>
            </button>
            <template v-else-if="offer?.id">
                <PayButtons v-if="!isOnlineGame && productPaymentMethods.length && mobile" :paymentMethods="productPaymentMethods" @pay="goToCheckout($event)"/>
                <button class="btn" :class="{
                        'offer-btn__remove-from-cart': offer.is_added_to_cart,
                        'offer-btn__add-to-cart': !offer.is_added_to_cart,
                        preload: loadBtn
                    }"
                    @click="addRemoveOfferToCart(offer?.id, !offer.is_added_to_cart)">
                    <svg v-if="offer.is_added_to_cart" width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M25.2772 12.1923L24.8571 25.1922C24.8213 26.3055 24.3626 27.3608 23.5784 28.1341C22.7941 28.9073 21.746 29.3376 20.6565 29.3336H12.6754C11.5867 29.3376 10.5392 28.9079 9.75503 28.1356C8.97087 27.3633 8.5117 26.3091 8.47485 25.1965L8.05479 12.1923C8.0456 11.9075 8.14743 11.6306 8.33787 11.4226C8.52831 11.2146 8.79177 11.0925 9.07028 11.0831C9.3488 11.0737 9.61956 11.1778 9.823 11.3725C10.0264 11.5672 10.1459 11.8366 10.1551 12.1214L10.5751 25.1245C10.5961 25.6796 10.8265 26.2048 11.2182 26.5899C11.6098 26.9749 12.1321 27.1898 12.6754 27.1894H20.6565C21.2005 27.1897 21.7234 26.9743 22.1152 26.5883C22.5069 26.2024 22.737 25.6761 22.7568 25.1202L23.1769 12.1214C23.1861 11.8366 23.3055 11.5672 23.509 11.3725C23.7124 11.1778 23.9832 11.0737 24.2617 11.0831C24.5402 11.0925 24.8036 11.2146 24.9941 11.4226C25.1845 11.6306 25.2864 11.9075 25.2772 12.1923ZM26.6665 7.86611C26.6665 8.15089 26.5559 8.424 26.3589 8.62537C26.162 8.82674 25.8949 8.93986 25.6164 8.93986H7.71665C7.43813 8.93986 7.17102 8.82674 6.97408 8.62537C6.77714 8.424 6.6665 8.15089 6.6665 7.86611C6.6665 7.58133 6.77714 7.30822 6.97408 7.10685C7.17102 6.90549 7.43813 6.79236 7.71665 6.79236H10.9721C11.3048 6.79327 11.626 6.66758 11.8731 6.43973C12.1202 6.21189 12.2756 5.89819 12.3089 5.55969C12.3864 4.76564 12.7503 4.02952 13.3296 3.49477C13.9089 2.96001 14.6621 2.66493 15.4426 2.667H17.8894C18.6698 2.66493 19.4231 2.96001 20.0024 3.49477C20.5817 4.02952 20.9455 4.76564 21.023 5.55969C21.0564 5.89819 21.2118 6.21189 21.4589 6.43973C21.706 6.66758 22.0271 6.79327 22.3599 6.79236H25.6153C25.8938 6.79236 26.1609 6.90549 26.3579 7.10685C26.5548 7.30822 26.6655 7.58133 26.6655 7.86611H26.6665ZM14.132 6.79236H19.2021C19.0641 6.46996 18.9738 6.12833 18.9343 5.77874C18.9083 5.51407 18.7871 5.26869 18.5943 5.09015C18.4014 4.91161 18.1506 4.81262 17.8904 4.81236H15.4436C15.1835 4.81262 14.9327 4.91161 14.7398 5.09015C14.547 5.26869 14.4258 5.51407 14.3998 5.77874C14.3599 6.12839 14.2703 6.47001 14.132 6.79236ZM15.1895 23.0608V13.9178C15.1895 13.633 15.0788 13.3599 14.8819 13.1585C14.685 12.9572 14.4178 12.844 14.1393 12.844C13.8608 12.844 13.5937 12.9572 13.3968 13.1585C13.1998 13.3599 13.0892 13.633 13.0892 13.9178V23.0651C13.0892 23.3498 13.1998 23.623 13.3968 23.8243C13.5937 24.0257 13.8608 24.1388 14.1393 24.1388C14.4178 24.1388 14.685 24.0257 14.8819 23.8243C15.0788 23.623 15.1895 23.3498 15.1895 23.0651V23.0608ZM20.2449 23.0608V13.9178C20.2449 13.633 20.1342 13.3599 19.9373 13.1585C19.7403 12.9572 19.4732 12.844 19.1947 12.844C18.9162 12.844 18.6491 12.9572 18.4522 13.1585C18.2552 13.3599 18.1446 13.633 18.1446 13.9178V23.0651C18.1446 23.3498 18.2552 23.623 18.4522 23.8243C18.6491 24.0257 18.9162 24.1388 19.1947 24.1388C19.4732 24.1388 19.7403 24.0257 19.9373 23.8243C20.1342 23.623 20.2449 23.3498 20.2449 23.0651V23.0608Z" fill="white"/>
                    </svg>
                    <svg v-else width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M24.8023 22.225C24.8023 22.6039 24.5001 22.9015 24.1157 22.9015H10.9767C9.83663 22.9015 8.9165 21.995 8.9165 20.8722C8.9165 19.8441 9.68554 18.9916 10.7019 18.8699C10.7843 18.8428 10.8805 18.8428 10.9767 18.8428C11.1414 18.8428 11.3062 18.9106 11.4162 19.0187L11.004 20.1958C10.9904 20.1958 10.9904 20.1958 10.9767 20.1958C10.5921 20.1958 10.2899 20.4933 10.2899 20.8722C10.2899 21.251 10.5921 21.5487 10.9767 21.5487H24.1157C24.5001 21.5487 24.8023 21.8462 24.8023 22.225Z" fill="white"/>
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M8.55735 9.37431C8.60098 9.42838 9.34051 9.75739 10.085 10.0795C10.0877 10.0212 10.0952 9.96347 10.0818 9.90393L9.47765 7.19803C9.40845 6.88751 9.12952 6.66699 8.80696 6.66699H4.68678C4.30718 6.66699 4 6.96959 4 7.34351C4 7.71726 4.30718 8.01986 4.68678 8.01986H8.25499L8.55735 9.37431Z" fill="white"/>
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M24.8027 22.2252C24.8027 22.604 24.5005 22.9017 24.1161 22.9017H17.6562V21.5488H24.1161C24.5005 21.5488 24.8027 21.8463 24.8027 22.2252Z" fill="white"/>
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M27.3028 9.64376C27.1655 9.46781 26.9731 9.37305 26.7533 9.37305H8.56006L10.7027 18.8704L11.0048 20.1963H24.0066C24.3087 20.1963 24.5834 19.9932 24.6658 19.7091L27.4126 10.2389C27.4677 10.036 27.4264 9.80598 27.3028 9.64376Z" fill="white"/>
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M27.4121 10.2389L24.6654 19.7091C24.5829 19.9932 24.3083 20.1963 24.0061 20.1963H17.6562V9.37305H26.7529C26.9726 9.37305 27.165 9.46781 27.3023 9.64376C27.4259 9.80598 27.4672 10.036 27.4121 10.2389Z" fill="white"/>
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M13.3402 25.3342C12.4317 25.3342 11.6929 24.6063 11.6929 23.7115C11.6929 22.8167 12.4317 22.0889 13.3402 22.0889C14.2485 22.0889 14.9873 22.8167 14.9873 23.7115C14.9873 24.6063 14.2485 25.3342 13.3402 25.3342Z" fill="white"/>
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M21.3949 25.3342C20.4866 25.3342 19.7476 24.6063 19.7476 23.7115C19.7476 22.8167 20.4866 22.0889 21.3949 22.0889C22.3031 22.0889 23.0422 22.8167 23.0422 23.7115C23.0422 24.6063 22.3031 25.3342 21.3949 25.3342Z" fill="white"/>
                    </svg>
                </button>
            </template>
            <span v-else class="placeholder"></span>
        </div>
    </div>
</template>

<script>
import OfferSellerTooltip from './OfferSellerTooltip.vue';
import OfferSellerInfo from './OfferSellerInfo.vue';
import OfferIconsInfo from './OfferIconsInfo.vue';
import OfferTooltipInfo from './OfferTooltipInfo.vue';
import OfferDetailsModal from './OfferDetailsModal.vue';
import RegionOffer from './RegionOffer.vue';
import Bookmark from './Bookmark.vue';
import SocialOfferInfo from './SocialOfferInfo.vue';
import PayButtons from './PayButtons.vue';
import { renderAlertVue } from "/webpack-assets/vue/utils/common.js";

export default {
  components: {
        OfferSellerInfo,
        OfferSellerTooltip,
        OfferIconsInfo,
        OfferTooltipInfo,
        OfferDetailsModal,
        RegionOffer,
        Bookmark,
        SocialOfferInfo,
        PayButtons
  },
  emits: ['update-cart', 'tooltip-id-active', 'update:bookmark'],
  props: {
    offer: {
      type: Object,
      required: true
    },
    isRecommended: {
      type: Boolean,
      default: false,
    },
    isOnlineGame: {
      type: Boolean,
      default: false,
    },
    activeOfferTooltipId: {
        type: Number,
        default: null
    },
    bigDesktop: {
        type: Boolean,
        default: false
    },
    mobile: {
        type: Boolean,
        default: false
    },
    tablet: {
        type: Boolean,
        default: false
    },
    tabletMax: {
        type: Boolean,
        default: false
    }
  },
  data() {
    return {
        user: window.common.user || null,
        loadBtn: false,
        showModalSellerInfo: false,
        productPaymentMethods: window.settings.product.payment_methods,
        productData: window.settings.product.additional_data
    };
  },
  watch: {
    activeOfferTooltipId(newVal) {
        if (newVal === null && this.$refs.socialOfferInfo) {
            this.$refs.socialOfferInfo.closeList();
        }
    }
  },
  computed: {
    w1199() {
        return window.innerWidth <= 1199;
    }
  },
  methods: {
    formatCurrency(amount, symbol, isOnline = false, minAmount = 1) {
        const basePrice = minAmount * amount;
        let formatted = Number(basePrice)
            .toFixed(isOnline ? 0 : 2)
            .replace(/\B(?=(\d{3})+(?!\d))/g, ' ')
            .replace(',', '.');

        if(isOnline) {
            return symbol ? `${formatted} ${symbol}` : `${formatted}`
        } else {
            return `${symbol} ${formatted}`
        }
    },
    redirectToOffer(offerId) {
        const url = '/offer/' + offerId;
        window.open(url, '_blank').focus();
    },
    goToCheckout(methodId = null) {
        let amount = this.headOffer?.min_order_quantity ? this.headOffer.min_order_quantity : 1;
        const url = `/cart/add/${this.headOffer.id}?amount=${amount}&buy_now=1`;
        const params = new URLSearchParams(window.location.search);
        const offerCoupon = this.offer.coupon?.code ?? null;
        const couponParam = offerCoupon ?? params.get('coupon');

        const data = couponParam ? { coupon: couponParam } : {};
        $.ajax({
            url: url,
            method: 'POST',
            data: data,
            success: () => {
                window.updateMiniCarts(amount, this.headOffer.id, false, couponParam);

                const checkoutUrl = methodId
                    ? `/checkout?paymentMethodId=${methodId}`
                    : '/checkout';

                this.$nextTick(() => {
                    window.location = checkoutUrl;
                });
            },
            error: (xhr, status, error) => {
                console.error('Error adding to cart:', error);
            }
        });
    },
    formatCouponePrice(amount, symbol, code, minAmount = 1) {
        const basePrice = minAmount * amount;
        const discount = (basePrice * code) / 100;
        const newPrice = basePrice - discount;
        const formatted = Number(newPrice)
            .toFixed(2)
            .replace(/\B(?=(\d{3})+(?!\d))/g, ' ')
            .replace(',', '.');
        return `${symbol} ${formatted}`
    },
    copyToClipboard(copyData) {
        let tempTextarea = document.createElement('textarea');
        tempTextarea.value = copyData;
        document.body.appendChild(tempTextarea);
        tempTextarea.select();
        document.execCommand('copy');
        document.body.removeChild(tempTextarea);
        renderAlertVue(this.$t('Promo code has been successfully copied.'), 'success', 2000)
    },
    showModalSellerInfoFun(bool) {
        this.showModalSellerInfo = bool;
    },
    addRemoveOfferToCart(offerId, isAdd, amount = 1) {
        this.loadBtn = true;
        this.$emit('update-cart', { offerId, isAdd, amount });
        setTimeout(()=>{this.loadBtn = false},500)
    },
    toggleTooltipOffer(id) {
        let thisId = this.activeOfferTooltipId === id ? null : id;
        this.$emit('tooltip-id-active', thisId);
    },
    forwardUpdateCart(payload) {
        this.$emit('update-cart', payload);
    },
  }
};
</script>
  
<style lang="scss" scoped>
    .offer{
        width: 100%;
        height: 74px;
        border-radius: 8px;
        display: flex;
        flex-wrap: nowrap;
        align-items: center;
        gap: 30px;
        @media only screen and (max-width: 991px) {
            background-color: #FFFFFF;
            padding: 15px 20px;
            gap: 0;
            //border: 1px solid #fff;
            &:hover{
                box-shadow: -2px -2px 8px 0px #0000000D;
                background-color: #F6F5FA;
            }
            &.recommended{
                border: 1px solid #4E8Aff;
            }
        }
        @media only screen and (max-width: 767px) {
            height: auto;
            flex-direction: column;
            padding: 0;
            &:hover{
                box-shadow: none;
                background-color: #fff;
            }
        }
        &__discount{
            background: #00B2411A;
            padding: 5px 15px;
            display: flex;
            align-items: center;
            justify-content: space-between;
            width: 100%;
            &-left{
                display: flex;
                align-items: center;
                gap: 5px;
                &-title{
                    color: #1F1F1F;
                    font-family: "Avenir-Next", sans-serif;
                    font-weight: 400;
                    font-size: 12px;
                    line-height: 120%;
                }
                &-percent{
                    color: #00BB8C;
                    font-family: "Avenir-Next-DemiBold", sans-serif;
                    font-weight: 400;
                    font-size: 12px;
                    line-height: 120%;
                }
            }
            &-right{
                display: flex;
                align-items: center;
                gap: 10px;
                &-code{
                    color: #505050;
                    font-family: "Avenir-Next-DemiBold", sans-serif;
                    font-weight: 400;
                    font-size: 12px;
                    line-height: 120%;
                }
            }
        }
        &-body{
            height: 100%;
            width: 100%;
            background-color: #FFFFFF;
            border-radius: 8px 0 0 8px;
            transition: 0.4s;
            padding: 10px 0 10px 15px;
            position: relative;
            display: flex;
            align-items: center;
            justify-content: space-between;
            cursor: pointer;
            @media only screen and (max-width: 1199px) {
                min-width: 0;
            }
            @media only screen and (max-width: 991px) {
                background-color: transparent;
                padding: 0;
            }
            @media only screen and (max-width: 767px) {
                padding: 15px 20px;
                border-bottom: 1px solid #E5E5E5;
                flex-direction: column;
                border-radius: 0;
                &.dicount{
                    border-bottom: none;
                }
            }
            &::before{
                content: '';
                position: absolute;
                right: -25px;
                top: 0;
                width: 37px;
                height: 100%;
                border-radius: 0 8px 8px 0;
                transition: 0.4s;
                z-index: 1;
                background-color: #FFFFFF;
                transform: skew(-17deg);
                @media only screen and (max-width: 991px) {
                    content: none;
                }
            }
            &.tooltip-active{

            }
            &.recommended{
                border-top: 1px solid #4E8Aff;
                border-left: 1px solid #4E8Aff;
                border-bottom: 1px solid #4E8Aff;
                &::before{
                    border-top: 1px solid #4E8Aff;
                    border-right: 1px solid #4E8Aff;
                    border-bottom: 1px solid #4E8Aff;
                    top: -1px;
                    height: calc(100% + 2px);
                }
                @media only screen and (max-width: 991px) {
                    border: none;
                }
                @media only screen and (max-width: 767px) {
                    border-bottom: 1px solid #E5E5E5;
                    &.dicount{
                        border-bottom: none;
                    }
                }
            }
            &.placeholder-wrap{
                justify-content: space-between;
                cursor: default;
                &:hover{
                    background-color: #fff;
                    &::before{
                        background-color: #fff;
                    }
                }
            }
            &:hover{
                box-shadow: -2px -2px 8px 0px #0000000D;
                background-color: #F6F5FA;
                &::before{
                    background-color: #F6F5FA;
                    box-shadow: 10px -2px 8px 0px #0000000D;
                }
                @media only screen and (min-width: 1024px) {
                    .offer-body__price-top.discount-offer.game{
                        .discount-offer__percent{
                            max-width: 100%;
                        }
                        .discount-offer__percent-code{
                            width: 100%;
                            padding: 0 5px;
                            span{
                                @media only screen and (max-width: 1640px) {
                                    max-width: 35px;
                                }
                            }
                        }
                        .discount-offer__old-price{
                            width: 0;
                        }
                    }
                }
                @media only screen and (max-width: 991px) {
                    box-shadow: none;
                    background-color: transparent;
                }
            }
            &__seller{
                min-width: 220px;
                max-width: 220px;
                position: relative;
                @media only screen and (max-width: 1639px) {
                    min-width: 200px;
                    max-width: 200px;
                }
                @media only screen and (max-width: 991px) {
                    min-width: 250px;
                    max-width: 250px;
                }
                @media only screen and (max-width: 767px) {
                    width: 100%;
                    min-width: auto;
                    max-width: 100%;
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                }
                &:hover{
                    .seller-tooltip{
                        pointer-events: all;
                        opacity: 1;
                        @media only screen and (max-width: 767px) {
                            pointer-events: none;
                            opacity: 0;
                        }
                    }
                }
            }
            &__line{
                height: 54px;
                width: 1px;
                background-color: #E5E5E5;
                margin: 0 20px;
                z-index: 2;
                @media only screen and (max-width: 991px) {
                    margin: 0 10px;
                }
                @media only screen and (max-width: 767px) {
                    display: none;
                    &.mobile{
                        display: block;
                    }
                }
                &.hide-line{
                    @media only screen and (max-width: 1199px) {
                        display: none;
                    }
                }
            }
            &__edition{
                display: flex;
                align-items: center;
                gap: 5px;
                min-width: 205px;
                max-width: 205px;
                .flex-item{
                    white-space: nowrap;
                    width: 100%;
                    overflow: hidden;
                    -webkit-mask-image: linear-gradient(90deg, #fff 90%, transparent);
                }
                @media only screen and (max-width: 1199px) {

                }
            }
            &__region{
                display: flex;
                align-items: center;
                gap: 20px;
                max-width: 275px;
                width: 100%;
                &-online{
                    display: flex;
                    gap: 10px;
                    min-width: 0;
                    overflow: hidden;
                    width: 100%;
                    -webkit-mask-image: linear-gradient(90deg, #fff 95%, transparent);
                }
                @media only screen and (max-width: 1639px) {
                    max-width: 220px;
                }
                @media only screen and (max-width: 1199px) {
                    &.game{
                        display: none;
                    }
                }
            }
            &__price{
                z-index: 2;
                display: flex;
                flex-direction: column;
                width: 12%;
                @media only screen and (max-width: 1919px) {
                    &.online{
                        width: 20%;
                    }
                }
                @media only screen and (max-width: 1199px) {
                    width: 15%;
                    &.online{
                        width: 25%;
                    }
                }
                @media only screen and (max-width: 991px) {
                    width: auto;
                    &.game{
                        width: 20%;
                    }
                }
                @media only screen and (max-width: 767px) {
                    display: none;
                    &.mobile{
                        display: flex;
                    }
                }
                &-top{
                    font-family: "Avenir-Next", sans-serif;
                    font-weight: 400;
                    font-size: 14px;
                    line-height: 140%;
                    letter-spacing: 0px;
                    vertical-align: middle;
                    color: #9D9D9D;
                    white-space: nowrap;
                    @media only screen and (max-width: 1640px) {
                        max-width: 122px;
                    }
                    :deep(b){
                        font-family: "Avenir-Next-DemiBold", sans-serif;
                    }
                    @media only screen and (max-width: 991px) {
                        font-size: 12px;
                    }
                    &.placeholder{
                        width: 87px;
                        height: 14px;
                        margin-bottom: 5px;
                        border-radius: 14px;
                        @media only screen and (max-width: 991px) {
                            width: 50px;
                            height: 14px;
                        }
                    }
                    &.discount-offer{
                        justify-content: space-between;
                        .discount-offer__percent-code{
                            display: none;
                        }
                        &.game{
                            .discount-offer__percent{
                                display: flex;
                                align-items: center;
                                transition: 0.4s;
                                max-width: 45px;
                                height: 22px;
                                width: 100%;
                                &-code{
                                    transition: 0.4s;
                                    display: flex;
                                    align-items: center;
                                    overflow: hidden;
                                    width: 0;
                                    padding: 0;
                                    img{
                                        padding-left: 5px;
                                    }
                                }
                            }
                            .discount-offer__old-price{
                                transition: 0.4s;
                                overflow: hidden;
                                width: 100%;
                                text-align: right;
                                @media only screen and (min-width: 1920px) {
                                    text-align: left;
                                }
                            }
                        }
                    }
                }
                &-bottom{
                    font-family: "Avenir-Next-DemiBold", sans-serif;
                    font-weight: 400;
                    font-size: 24px;
                    line-height: 140%;
                    letter-spacing: 0px;
                    vertical-align: middle;
                    color: #1F1F1F;
                    white-space: nowrap;
                    @media only screen and (max-width: 991px) {
                        font-size: 18px;
                    }
                    @media only screen and (max-width: 767px) {
                        font-size: 16px;
                        line-height: 24px;
                    }
                    .bold-price{
                        font-family: "Avenir-Next-DemiBold", sans-serif !important;
                    }
                    &.placeholder{
                        width: 145px;
                        height: 24px;
                        border-radius: 22px;
                        @media only screen and (max-width: 991px) {
                            width: 80px;
                            height: 20px;
                        }
                    }
                }
                &.online{
                    align-items: center;
                    .offer-body__price-bottom {
                        font-family: "Avenir-Next", sans-serif;
                        color: #505050;
                    }
                    &.stock{
                        @media only screen and (max-width: 1199px) {
                            display: none;
                        }
                        @media only screen and (max-width: 991px) {
                            display: block;
                        }
                        @media only screen and (max-width: 767px) {
                            font-family: "Avenir-Next", sans-serif !important;
                        }
                    }
                    @media only screen and (max-width: 1919px) {
                        .offer-body__price-top.discount-offer{
                            max-width: 100%;
                        }
                    }
                    @media only screen and (max-width: 767px) {
                        .offer-body__price-top{
                            text-align: center;
                        }
                        .offer-body__price-bottom{
                            font-size: 14px;
                            line-height: 20px;
                            font-family: "Avenir-Next-DemiBold", sans-serif;
                            font-weight: 400;
                            text-align: center;
                        }
                    }
                    
                }
            }
            &__tooltip{
                position: relative;
                padding-right: 10px;
                @media only screen and (max-width: 991px) {
                    padding-right: 15px;
                }
                @media only screen and (max-width: 767px) {
                    padding-right: 0;
                }
                &-btn{
                    display: flex;
                    align-items: center;
                    svg path{
                        transition: 0.4s;
                    }
                    &:hover{
                        svg path{
                            fill: #4E8AFF;
                        }
                    }
                }
                &-body{
                    position: absolute;
                    top: 30px;
                    right: 0;
                    box-shadow: 0px 2px 10px 0px #00000040;
                    border-radius: 16px;
                    background-color: #fff;
                    overflow: hidden;
                    display: flex;
                    flex-direction: column;
                    width: 220px;
                    opacity: 0;
                    pointer-events: none;
                    transition: 0.4s;
                    z-index: -1;
                    transition:
                        opacity 0.3s ease,
                        visibility 0s 0.3s,
                        z-index 0s 0.3s;
                    visibility: hidden;
                    &.active{
                        opacity: 1;
                        pointer-events: all;
                        visibility: visible;
                        z-index: 1000;
                        transition:
                            opacity 0.3s ease,
                            visibility 0s 0s,
                            z-index 0s 0s;
                    }
                }
            }
            &__mobile{
                display: flex;
                align-items: center;
                width: 100%;
                padding-top: 10px;
                &-region{
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    width: 100%;
                    padding-left: 10px;
                    margin-left: 10px;
                    border-left: 1px solid #E5E5E5;
                }
            }
            // .offer-icons-info{
            //     min-width: 150px;
            // }
        }
        &-btn{
            min-width: 84px;
            height: 100%;
            border-radius: 8px;
            max-width: 84px;
            background-size: 100%;
            background-position: center 0;
            background-repeat: no-repeat;
            mask-image: url('/webpack-assets/img/product/mask-btn.webp');
            mask-repeat: no-repeat;
            mask-size: 100% 74px;
            mask-position: 0 0;
            cursor: pointer;
            transition: 0.4s;
            @media only screen and (max-width: 991px) {
                mask-image: none;
                min-width: 55px;
                height: 100%;
                border-radius: 8px;
                max-width: 55px;
                height: 55px;
                padding: 0;
            }
            @media only screen and (max-width: 767px) {
                padding: 15px 20px;
                display: flex;
                width: 100%;
                align-items: center;
                justify-content: space-between;
                max-width: none;
                min-width: none;
                height: auto;
                gap: 10px;
                .offer-body__line{
                    height: 38px;
                }
            }
            &__add-to-cart{
                background-color: #4E8AFF;
                &:hover{
                    background-color: #1767FF;
                }
            }
            &__remove-from-cart{
                background-color: #F43232;
                &:hover{
                    background-color: #C32828;
                }
            }
            .btn{
                padding: 21px 20px 21px 32px;
                width: 100%;
                height: 100%;
                display: flex;
                align-items: center;
                justify-content: center;
                transition: 0.4s;
                @media only screen and (max-width: 991px) {
                    padding: 0;
                }
                @media only screen and (max-width: 767px) {
                    width: 38px;
                    height: 38px;
                    min-width: 38px;
                    border-radius: 8px;
                    svg{
                        width: 24px;
                        height: 24px;
                    }
                }
                &.preload {
                    position: relative;
                    svg {
                        opacity: 0;
                    }
                    span {
                        opacity: 0;
                    }
                    &::before {
                        content: "";
                        position: absolute;
                        top: 36%;
                        right: 28%;
                        -webkit-transform: translate(-50%, -50%);
                        -ms-transform: translate(-50%, -50%);
                        -moz-transform: translate(-50%, -50%);
                        transform: translate(-50%, -50%);
                        width: 21px;
                        height: 21px;
                        background: url("/webpack-assets/img/icons/gray-prelodader.svg") center
                            center no-repeat;
                        background-size: 100%;
                        animation: rot 1s infinite linear;
                        @media only screen and (max-width: 767px) {
                            right: 21%;
                            top: 22%;
                        }
                    }
                }
            }
            &.placeholder-wrap{
                background-color: #fff;
                .placeholder{
                    width: 32px;
                    height: 32px;
                    border-radius: 8px;
                }
            }
        }
    }
</style>